import React from "react";
import { Navigate, createBrowserRouter } from "react-router-dom";
import GuestLayout from "./Components/Layouts/guestLayout";
import Login from "./Pages/Authentication/Login";
import SetupPasswordPage from "./Pages/Authentication/SetupPasswordPage";
import DefaultLayout from "./Components/Layouts/DefaultLayout";
import Homepage from "./Pages/Home/Dashboard/Homepage";
import MyProfile from "./Pages/Home/Profile/my_profile";
import ChangePassword from "./Pages/Home/Profile/ChangePassword";
import Invoices from "./Pages/Home/Invoice/Invoices";
import Subscription from "./Pages/Home/SubscriptionManagement/Subscription";
import EditSubscription from "./Pages/Home/SubscriptionManagement/EditSubscription";
import AddSubscription from "./Pages/Home/SubscriptionManagement/AddSubscription";
import CustomerIndex from "./Pages/Home/Customer/CustomerIndex";
import CustomerProfileIndex from "./Pages/Home/Customer/CustomerProfileIndex";
import RefferalIndex from "./Pages/Home/Referrals/Index";
import AddPromoCode from "./Pages/Home/Referrals/AddPromoCode";
import SpecialLayout from "./Components/Layouts/SpecialLayout";
import InvoiceViewPage from "./Pages/Home/Invoice/InvoiceViewPage";
import UserManagement from "./Pages/Home/UserManagement/userManagement";
import AddUserPage from "./Pages/Home/UserManagement/AddUserPage";
import AuditTrial from "./Pages/Home/AuditTrial/auditTrial";
import Reports from "./Pages/Home/Reports/reports";
import Communication from "./Pages/Home/Communication/communication";
import CreateNotificationPage from "./Pages/Home/Communication/createNotification";
import SuportTicketIndex from "./Pages/Home/SupportTicket/suportTicketIndex";
import CreateSupportTicket from "./Pages/Home/SupportTicket/createSupportTicket";
import FeedBackIndex from "./Pages/Home/Feedback/feedbackIndex";
import InviteNewCustomer from "./Pages/Home/Customer/InviteNewCustomer";
import CommunicationViewPage from "./Pages/Home/Communication/communicationViewPage";
import TeamLeaderContactUs from "./Pages/Home/Contact Us/teamLeadercontactUs";
import NotificationsPage from "./Components/notificationsPage";
import PermissionRoute, { HomeRedirect } from "./Components/PermissionRoute";

const Router = createBrowserRouter([
  {
    path: "/",
    element: <GuestLayout />,
    children: [
      {
        path: "/",
        element: <Navigate to="/login" />,
      },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/setup-password",
        element: <SetupPasswordPage />,
      },
    ],
  },
  {
    path: "/",
    element: <SpecialLayout />,
    children: [
      {
        path: "/invoices/:name",
        element: <InvoiceViewPage />,
      },
    ],
  },
  {
    path: "/",
    element: <DefaultLayout />,
    children: [
      {
        path: "/",
        element: <HomeRedirect />,
      },
      {
        path: "/home",
        element: <HomeRedirect />,
      },
      {
        path: "/dashboard",
        element: (
          <PermissionRoute permission="dashboard">
            <Homepage />
          </PermissionRoute>
        ),
      },
      {
        path: "/my-profile",
        element: <MyProfile />,
      },
      {
        path: "/customers",
        element: (
          <PermissionRoute permission="customers">
            <CustomerIndex />
          </PermissionRoute>
        ),
      },
      {
        path: "/customers/invite",
        element: (
          <PermissionRoute permission="customers">
            <InviteNewCustomer />
          </PermissionRoute>
        ),
      },
      {
        path: "/reset-password",
        element: <ChangePassword />,
      },
      {
        path: "/customer/profile/:id",
        element: (
          <PermissionRoute permission="customers">
            <CustomerProfileIndex />
          </PermissionRoute>
        ),
      },
      {
        path: "/referrals",
        element: (
          <PermissionRoute permission="referrals">
            <RefferalIndex />
          </PermissionRoute>
        ),
      },
      {
        path: "/referrals/add-promocode",
        element: (
          <PermissionRoute permission="referrals">
            <AddPromoCode />
          </PermissionRoute>
        ),
      },
      {
        path: "/referrals/edit-promocode/:id",
        element: (
          <PermissionRoute permission="referrals">
            <AddPromoCode />
          </PermissionRoute>
        ),
      },
      {
        path: "/invoicing",
        element: (
          <PermissionRoute permission="invoicing">
            <Invoices />
          </PermissionRoute>
        ),
      },
      {
        path: "/subscription-management",
        element: (
          <PermissionRoute permission="subscriptionManagement">
            <Subscription />
          </PermissionRoute>
        ),
      },
      {
        path: "/subscription-management/add",
        element: (
          <PermissionRoute permission="subscriptionManagement">
            <AddSubscription />
          </PermissionRoute>
        ),
      },
      {
        path: "/subscription-management/edit",
        element: (
          <PermissionRoute permission="subscriptionManagement">
            <EditSubscription />
          </PermissionRoute>
        ),
      },
      {
        path: "/user-management",
        element: (
          <PermissionRoute superOnly>
            <UserManagement />
          </PermissionRoute>
        ),
      },
      {
        path: "/user-management/add-user",
        element: (
          <PermissionRoute superOnly>
            <AddUserPage />
          </PermissionRoute>
        ),
      },
      {
        path: "/audit-trial",
        element: (
          <PermissionRoute permission="auditTrail">
            <AuditTrial />
          </PermissionRoute>
        ),
      },
      {
        path: "/reports",
        element: (
          <PermissionRoute permission="reports">
            <Reports />
          </PermissionRoute>
        ),
      },
      {
        path: "/communication",
        element: (
          <PermissionRoute permission="communication">
            <Communication />
          </PermissionRoute>
        ),
      },
      {
        path: "/communication/create-notification",
        element: (
          <PermissionRoute permission="communication">
            <CreateNotificationPage />
          </PermissionRoute>
        ),
      },
      {
        path: "/communication/edit-notification/:id",
        element: (
          <PermissionRoute permission="communication">
            <CreateNotificationPage />
          </PermissionRoute>
        ),
      },
      {
        path: "/communication/:id",
        element: (
          <PermissionRoute permission="communication">
            <CommunicationViewPage />
          </PermissionRoute>
        ),
      },
      {
        path: "/support-tickets",
        element: (
          <PermissionRoute permission="supportTickets">
            <SuportTicketIndex />
          </PermissionRoute>
        ),
      },
      {
        path: "/support-tickets/create-ticket",
        element: (
          <PermissionRoute permission="supportTickets">
            <CreateSupportTicket />
          </PermissionRoute>
        ),
      },
      {
        path: "/feedback",
        element: (
          <PermissionRoute permission="feedback">
            <FeedBackIndex />
          </PermissionRoute>
        ),
      },
      {
        path: "/contact-us",
        element: <TeamLeaderContactUs />,
      },
      {
        path: "/notifications",
        element: <NotificationsPage />,
      },
      {
        basename: "/admin",
      },
    ],
  },
]);
export default Router;
